export const coronairSclerosePercentages: ICoronairSclerosePercentages = {
    30: {
        aspecifiekeThorocalePijn: {
            male: 18,
            female: 5,
        },
        atypischeAnginaPectoris: {
            male: 29,
            female: 10,
        },
        typischeAnginaPectoris: {
            male: 59,
            female: 28,
        },
    },
    40: {
        aspecifiekeThorocalePijn: {
            male: 25,
            female: 8,
        },
        atypischeAnginaPectoris: {
            male: 38,
            female: 14,
        },
        typischeAnginaPectoris: {
            male: 69,
            female: 37,
        },
    },
    50: {
        aspecifiekeThorocalePijn: {
            male: 34,
            female: 12,
        },
        atypischeAnginaPectoris: {
            male: 49,
            female: 20,
        },
        typischeAnginaPectoris: {
            male: 77,
            female: 47,
        },
    },
    60: {
        aspecifiekeThorocalePijn: {
            male: 44,
            female: 17,
        },
        atypischeAnginaPectoris: {
            male: 59,
            female: 27,
        },
        typischeAnginaPectoris: {
            male: 64,
            female: 58,
        },
    },
    70: {
        aspecifiekeThorocalePijn: {
            male: 54,
            female: 24,
        },
        atypischeAnginaPectoris: {
            male: 69,
            female: 37,
        },
        typischeAnginaPectoris: {
            male: 89,
            female: 68,
        },
    },
    80: {
        aspecifiekeThorocalePijn: {
            male: 65,
            female: 32,
        },
        atypischeAnginaPectoris: {
            male: 78,
            female: 47,
        },
        typischeAnginaPectoris: {
            male: 93,
            female: 76,
        },
    },
};

interface ICoronairSclerosePercentages {
    [key: number]: {
        aspecifiekeThorocalePijn: {
            female: number;
            male: number;
        };
        atypischeAnginaPectoris: {
            female: number;
            male: number;
        };
        typischeAnginaPectoris: {
            female: number;
            male: number;
        };
    };
}
